import React from "react";
import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import ErrorMessage from "@/ui/atoms/ErrorMessage";

import { Button } from "@proda-ai/ui-kit";

export type MessageWithButtonProps = BoxProps & {
    variant: "error" | "info";
    header?: React.ReactNode;
    message?: React.ReactNode;
    buttonLabel?: React.ReactNode;
    buttonAction?: () => void;
};

const testId = "MessageWithButton";
const MessageWithButton = (props: MessageWithButtonProps) => {
    const {
        sx,
        className,
        variant,
        header,
        message,
        buttonLabel,
        buttonAction,
        ...otherProps
    } = props;

    const goToMainPage = React.useCallback(() => {
        window.location.href = window.location.origin;
    }, []);

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                textAlign: "center",
                ...sx,
            }}
            {...otherProps}
        >
            <Typography
                variant="h2"
                sx={{ marginBottom: "24px", textAlign: "center" }}
            >
                {header ?? "Oops, Something went wrong!"}
            </Typography>
            {variant === "error" && (
                <ErrorMessage sx={{ marginBottom: "24px", fontWeight: 500 }}>
                    {message ?? "An unexpected error occurred."}
                    {}
                </ErrorMessage>
            )}
            {variant === "info" && (
                <Typography
                    sx={{ marginBottom: "24px", fontWeight: 500 }}
                    variant="body2"
                >
                    {message}
                    {}
                </Typography>
            )}
            <Button
                onClick={buttonAction || goToMainPage}
                style={{
                    width: "158px",
                    height: "40px",
                }}
            >
                {buttonLabel ?? "Go Back to Main Page"}
            </Button>
        </Box>
    );
};

export default MessageWithButton;
